import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { openSpeakerModal } from "ActionsSpeakers";
import {
  insertSocial,
  openSocialModal,
  clearLoadEditSocialData,
} from "ActionsSocial";
import { checkContentDashboardStatus } from "GeneralTabAction";
import {
  COMMON_FAIL_MESSAGE,
  DEVELOPMENT_TYPE,
  INSTAGRAM_CLIENTID,
  MAIN_URL,
  validateUrl,
} from "Constants";
import LocaleStrings from "Languages";

class AddSocial extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.openLinkedin.bind(this);
    this.open = this.openInstagram.bind(this);

    this.open = this.openFacebook.bind(this);
    this.open = this.openTwitter.bind(this);
    this.open = this.openRss.bind(this);
    this.close = this.close.bind(this);
    this.state = { loading: false, linkFieldName: "", linkFieldLable: "" };

    this.open = this.callInstagramUrl.bind(this); // new instagram connect link
  }

  openLinkedin() {
    this.props.reset();
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: "linkedin",
      linkFieldLable: "Linkedin",
    });
  }

  openInstagram() {
    this.props.reset();
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: "instagram",
      linkFieldLable: "Instagram",
    });
  }

  /* Call instagram url to login */
  callInstagramUrl() {
    let { session } = this.props;

    //let instagramURL = `https://www.instagram.com/oauth/authorize?client_id=632574764506776&scope=user_profile,user_media&response_type=code&state=0&eventid=1711141927827745&redirect_uri=https://dev.eventify.io/%23/dashboard/content/social`;
    let instagramURL = `https://www.instagram.com/oauth/authorize?client_id=${INSTAGRAM_CLIENTID}&scope=user_profile,user_media&response_type=code&state=0&eventid=${session.eventid}&redirect_uri=${MAIN_URL}/dashboard/content/social`;

    window.open(instagramURL, "_top");
    //-> It may causing problem in url for now we are removing it
    //window.open(instagramURL);
  }

  openFacebook() {
    this.props.reset();
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: "facebook",
      linkFieldLable: "Facebook",
    });
  }

  openTwitter() {
    this.props.reset();
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: "twitter",
      linkFieldLable: "Twitter",
    });
  }

  openRss() {
    this.props.reset();
    this.props.openSocialModal({
      showModal: true,
      linkFieldName: "rss",
      linkFieldLable: "RSS Feed",
    });
  }

  close() {
    this.props.openSocialModal({ showModal: false });
    this.props.clearLoadEditSocialData();
  }

  onFormSubmit(values) {
    values["twitter"] = values.twitter.replaceAll(/\s/g, "");
    var data = { ...values };
    var social = this.props.initialValues;
    this.setState({ loading: true });
    this.props.insertSocial(this.props.session, data, social, (result) => {
      if (result.error) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.reset();
        this.close();
        this.props.showSuccess(
          DEVELOPMENT_TYPE === "koachify"
            ? "Activity link updated successfully!"
            : "Social updated successfully!"
        );
        this.props.checkContentDashboardStatus(this.props.session);
      }
      this.setState({ loading: false });
    });
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid } = this.props;
    var placeholder = "default";
    var linkFieldName = "default";
    var linkFieldLable = "default";

    if (this.props.modalData.linkFieldLable !== undefined) {
      placeholder = `${"Enter"} ${
        this.props.modalData.linkFieldLable
      } ${"link"}`;
      linkFieldName = this.props.modalData.linkFieldName;
      linkFieldLable = this.props.modalData.linkFieldLable;
    }

    var edit = false;
    if (!_.isEmpty(this.props.initialValues)) {
      edit = true;
    }

    let header = `${edit ? `Edit` : `Add`} Social Link`;
    if (linkFieldName == "instagram") {
      header = `${edit ? `Edit` : `Add`} Social Link OR #tag`;
      placeholder = `${"Enter your"} ${
        this.props.modalData.linkFieldName
      } ${"handle link only or hashtag"}`;
    }

    return (
      <div style={{ display: "flex" }}>
        {/* <button onClick={this.openLinkedin.bind(this)} className="btn btn-linkedin" type="button">Add Linkedin</button> */}

        {/* // Cuurent code hidden for hub ~Tapas */}
        {/* <button
          onClick={this.callInstagramUrl.bind(this)}
          className="btn btn-instagram"
          type="button"
        >
          <img
            className="mr-15"
            src="../../style/images/custom-icons/instagram.svg"
          />
          {LocaleStrings.social_add_instagram}
        </button> */}
        {/* <button onClick={this.openFacebook.bind(this)} className="btn btn-facebook" type="button">Add Facebook</button> */}
        <button
          onClick={this.openTwitter.bind(this)}
          className="btn btn-twitter ml-10"
          type="button"
        >
          <img
            className="mr-15"
            src="../../style/images/custom-icons/twitter.svg"
          />
          {LocaleStrings.social_add_twitter}
        </button>
        {/* <button
          onClick={this.openRss.bind(this)}
          className="btn btn-rss"
          type="button"
          style={{ marginLeft: 10 }}
        >
          <img
            className=""
            style={{ marginRight: 20 }}
            src="../../style/images/custom-icons/wifi.svg"
          />
          Add RSS Feed
        </button> */}

        <div>
          <Modal
            className="modal-container"
            show={this.props.modalData.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            size="lg"
          >
            <form
              onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
              encType="multipart/form-data"
            >
              <Modal.Header>
                <div className="import-modal-title">{header}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <Field
                  name={linkFieldName}
                  label={this.props.modalData.linkFieldLable}
                  placeholder={placeholder}
                  type="text"
                  mandatory="true"
                  component={this.renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => this.close()}
                  className="btn btn-custom-white"
                  type="button"
                >
                  {LocaleStrings.button_close}
                </button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  type="submit"
                  disabled={pristine || invalid || submitting}
                >
                  {LocaleStrings.button_save_changes}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    modalData: state.socialModel,
    initialValues: state.social,
  };
}

function validate(values, props) {
  var errors = {};
  var requiredFields = ["linkedin", "instagram", "facebook", "twitter", "rss"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = LocaleStrings.required;
    }
  });

  let regexp1 = /^[a-zA-Z\d\-_.:/\s]+$/; // This is for only allow url without params (eg: https://www.instagram.com/thetimesofindia/)

  requiredFields.forEach((field) => {
    let value = values[field];
    let socialType = _.findKey(values, _.partial(_.isEqual, value));

    if (socialType == "instagram") {
      let firstChar = value ? value.charAt(0) : "";
      if (firstChar == "#") {
        if (value.length < 2) {
          errors[field] = "Invalid " + field + " #tag";
        }
      } else {
        if (
          !validateUrl(value) ||
          !_.includes(value, props.modalData.linkFieldName)
        ) {
          errors[field] = "Invalid " + field + " url";
        }
        if (socialType == "twitter" && !regexp1.test(value)) {
          errors[field] =
            "Enter only you twitter handle. No extra params required";
        }
      }
    } else if (
      socialType == "twitter" ||
      socialType == "linkedin" ||
      socialType == "facebook" ||
      socialType == "rss"
    ) {
      if (
        !validateUrl(value) ||
        !_.includes(value, props.modalData.linkFieldName)
      ) {
        errors[field] = "Invalid " + field + " url";
      }
    }
  });
  // ===== //

  // if(values.linkedin) {
  //   if(!_.includes(values.linkedin,props.modalData.linkFieldName)){
  //     errors['linkedin']="Invalid linkedin link";
  //   }
  // }

  // if(values.instagram) {
  //   if(!_.includes(values.instagram,props.modalData.linkFieldName)){
  //     errors['instagram']="Invalid instagram link";
  //   }
  // }

  // if(values.facebook) {
  //   if(!_.includes(values.facebook,props.modalData.linkFieldName)){
  //     errors['facebook']="Invalid facebook link";
  //   }
  // }

  // if(values.twitter) {
  //   if(!_.includes(values.twitter,props.modalData.linkFieldName)){
  //     errors['twitter']="Invalid twitter link";
  //   }
  // }

  // if(values.rss) {
  //   if(!_.includes(values.rss,props.modalData.linkFieldName)){
  //     errors['rss']="Invalid rss link";
  //   }
  // }

  return errors;
}

export default connect(mapStateToProps, {
  openSpeakerModal,
  showError,
  showSuccess,
  insertSocial,
  openSocialModal,
  clearLoadEditSocialData,
  checkContentDashboardStatus,
})(
  reduxForm({
    validate,
    form: "AddSocialForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddSocial)
);
